export const FYMW_REQUEST = "FYMW_REQUEST";
export const FYMW_SUCCESS = "FYMW_SUCCESS";
export const FYMW_FAIL = "FYMW_FAIL";